import { useEffect } from 'react';

const SEO = ({ title, description }) => {
  const siteName = 'Life Care and Wellness';
  const fullTitle = title ? title + ' | ' + siteName : siteName + ' | NDIS Support Services Brisbane & Logan';
  const desc = description || 'Life Care and Wellness provides trusted NDIS disability support services in Brisbane, Logan, Gold Coast. Support Coordination, Mental Health, SLES, Counselling and more.';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector('meta[' + attr + '="' + key + '"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', desc);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', siteName);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);
  }, [fullTitle, desc]);

  return null;
};

export default SEO;
